import type { PrescribedPrograms } from '@/modules/api';

/** Sparta's ProgramRecommendationType enum (Datadog global-context value). */
export type ProgramRecommendationType =
  | 'SoftRecommended'
  | 'HardRecommended'
  | 'Prescribed'
  | 'None';

// Datadog enum → PostHog `program_recommend_type` attribute value.
const POSTHOG_VALUE: Record<ProgramRecommendationType, string> = {
  SoftRecommended: 'soft_recommend',
  HardRecommended: 'hard_recommend',
  Prescribed: 'prescribe',
  None: 'none',
};

/**
 * Classifies the prescribe-programs catalog the way Sparta's loadProgramSuccessEpic
 * does, returning both the Datadog global-context value and the PostHog attribute
 * value:
 *   goStraightToDetailsPage + additionalChoicesAllowed → HardRecommended
 *   goStraightToDetailsPage (only)                     → Prescribed
 *   neither                                            → SoftRecommended
 *   no programs                                        → None
 */
export function programRecommendationType(catalog: PrescribedPrograms): {
  datadog: ProgramRecommendationType;
  posthog: string;
} {
  let type: ProgramRecommendationType;
  if (catalog.programs.length === 0) {
    type = 'None';
  } else if (catalog.additionalChoicesAllowed && catalog.goStraightToDetailsPage) {
    type = 'HardRecommended';
  } else if (catalog.goStraightToDetailsPage) {
    type = 'Prescribed';
  } else {
    type = 'SoftRecommended';
  }
  return { datadog: type, posthog: POSTHOG_VALUE[type] };
}
